import request from '../request'

export default {
  getModelsByPosition: (params) => {
    return request.get('/simulacion/getModelsByPosition', { params })
  },

  getModelFuel: () => {
    return request.get('/simulacion/getModelFuel')
  },

  getSimulatorMeteo: (params) => {
    return request.get('/simulacion/getSimulatorMeteo', { params })
  },

  getSimulaciones(data) {
    return request.get('simulacion', { params: data })
  },

  addSimulacion(data) {
    return request.post('simulacion', data)
  },

  updateSimulacion(data) {
    return request.put('simulacion/update', { params: data })
  },

  deleteSimulacionBDD(idSimulacion) {
    return request.delete(`simulacion/${idSimulacion}`)
  },

  generateCallback(type) {
    return request.get('simulacion/generateCallback')
  },

  setStatusSimulationRepo(idSimulation, status) {
    return request.post('simulacion/setStatusSimulationRepo', { idSimulation, status })
  },

  getSimulationStatus(idSimulacion) {
    return request.get('simulacion/getSimulationStatus', idSimulacion)
  },

  simulate(datosSimulador) {
    return request.post('simulacion/generateSim', datosSimulador)
  },

  simulateWind(datosSimulador) {
    return request.post('simulacion/generateSimWind', datosSimulador)
  },

  getSimulacion(idSimulacion, epsg) {
    return request.get(`simulacion/getSim/id/${idSimulacion}`, epsg)
  },

  getSimulacionWind(idSimulacion, fecha) {
    return request.get(`simulacion/getWindSim/id/${idSimulacion}/${fecha}`)
  },

  getJsonWindNinja(idSimulacion, fecha) {
    return request.get(`simulacion/devolverJsonWindNinja/${idSimulacion}/${fecha}`)
  },

  getFlameLength(idSimulacion, epsg) {
    return request.get(`simulacion/getFlameLength/${idSimulacion}/${epsg}`)
  },

  getIntensity(idSimulacion, epsg) {
    return request.get(`simulacion/getIntensity/${idSimulacion}/${epsg}`)
  },

  getSpreadRate(idSimulacion, epsg) {
    return request.get(`simulacion/getSpreadRate/${idSimulacion}/${epsg}`)
  },

  getInformeSimulacion(idSimulacion) {
    return request.get(`simulacion/report_meteo/${idSimulacion}`)
  },

  exportSimulacion(idSimulacion, tipo, fechas, responseType, fileType) {
    return request.post(`simulacion/${idSimulacion}/${tipo}/${fechas}/${responseType}/${fileType}`, {}, {
      responseType
    })
  },

  getSimulationPDF(idSimulation) {
    return request.get(`/simulacion/getSimulationPDF/${idSimulation}`, { responseType: 'blob' })
  }
}
